import { useLayoutEffect, useState } from 'react';

const useElementHeight = <T extends HTMLElement>() => {
    const [element, setElement] = useState<T | null>(null);
    const [height, setHeight] = useState(0);

    useLayoutEffect(() => {
        if (!element) {
            setHeight(0);
            return;
        }
        const updateHeight = () => setHeight(element.offsetHeight);
        updateHeight();
        if (typeof ResizeObserver === 'undefined') return;
        const observer = new ResizeObserver(updateHeight);
        observer.observe(element, { box: 'border-box' });
        return () => observer.disconnect();
    }, [element]);

    return [setElement, height] as const;
};

export default useElementHeight;
